export enum PrefixApiPortalEnum {
  australia = 'https://cloud-au.flexicapture.com',
  europe = 'https://cloud-eu.flexicapture.com',
  usa = 'https://cloud-us.flexicapture.com',
  stage01 = 'https://cloud-stage.flexicapture.com',
  'acs-frontend-flexicapture-host' = 'http://localhost:4200'
};
